import React from 'react';
import '../template-file-css/document-file-template.css';


export const FWC_ServicePlanDevelopment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='FWC_ServicePlanDevelopment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center> <h2> <b> Service Plan Development (SPD) </b> </h2> </center>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Allergies:</span>
                    <input type='text' id='txtAllergies_1' name='txtAllergies_1' placeholder='1.' className='add-only' />
                    <input type='text' id='txtAllergies_2' name='txtAllergies_2' placeholder='2.' className='add-only' />
                    <input type='text' id='txtAllergies_3' name='txtAllergies_3' placeholder='3.' className='add-only' />
                </p>

                <p className='w-750'>
                    <center> <b> Participants Involved in Plan Development </b> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'> 1. Name (person to whom this plan belongs): </span></td>
                        <td className='w-375'><span className='eleHeader'> Relation/Agency: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtName_1' name='txtName_1' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtRelationAgency_1' name='txtRelationAgency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Role: </span>

                            <input type='checkbox' id='cbFacilitatorOfIrpTeamMeeting_1' name='cbFacilitatorOfIrpTeamMeeting_1' className='add-only' value='Facilitator of IRP team meeting(s)' /> Facilitator of IRP team meeting(s) <br />
                            <input type='checkbox' id='cbParticipatedPlanningMeeting_1' name='cbParticipatedPlanningMeeting_1' className='add-only' value='Participated in @ least 1 planning meeting' /> Participated in @ least 1 planning meeting <br />
                            <input type='checkbox' id='cbProvidedWrittenInput_1' name='cbProvidedWrittenInput_1' className='add-only' value='Provided written input' /> Provided written input <br />
                            <input type='checkbox' id='cbTelephoneParticipation_1' name='cbTelephoneParticipation_1' className='add-only' value='Telephone participation' /> Telephone participation <br />
                            <input type='checkbox' id='cbInvitedButNoParticipation_1' name='cbInvitedButNoParticipation_1' className='add-only' value='Invited, but no participation' /> Invited, but no participation <br />
                            <input type='checkbox' id='cbRoleOther_1' name='cbRoleOther_1' className='add-only' value='Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtRoleOther_1' name='txtRoleOther_1' className='add-only custom-add-only w-250' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'> 2. Name: </span></td>
                        <td className='w-375'><span className='eleHeader'> Relation/Agency: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtName_2' name='txtName_2' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtRelationAgency_2' name='txtRelationAgency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Role: </span>

                            <input type='checkbox' id='cbFacilitatorOfIrpTeamMeeting_2' name='cbFacilitatorOfIrpTeamMeeting_2' className='add-only' value='Facilitator of IRP team meeting(s)' /> Facilitator of IRP team meeting(s) <br />
                            <input type='checkbox' id='cbParticipatedPlanningMeeting_2' name='cbParticipatedPlanningMeeting_2' className='add-only' value='Participated in @ least 1 planning meeting' /> Participated in @ least 1 planning meeting <br />
                            <input type='checkbox' id='cbProvidedWrittenInput_2' name='cbProvidedWrittenInput_2' className='add-only' value='Provided written input' /> Provided written input <br />
                            <input type='checkbox' id='cbTelephoneParticipation_2' name='cbTelephoneParticipation_2' className='add-only' value='Telephone participation' /> Telephone participation <br />
                            <input type='checkbox' id='cbInvitedButNoParticipation_2' name='cbInvitedButNoParticipation_2' className='add-only' value='Invited, but no participation' /> Invited, but no participation <br />
                            <input type='checkbox' id='cbRoleOther_2' name='cbRoleOther_2' className='add-only' value='Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtRoleOther_1' name='txtRoleOther_1' className='add-only custom-add-only w-250' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'> 3. Name: </span></td>
                        <td className='w-375'><span className='eleHeader'> Relation/Agency: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtName_3' name='txtName_3' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtRelationAgency_3' name='txtRelationAgency_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Role: </span>

                            <input type='checkbox' id='cbFacilitatorOfIrpTeamMeeting_3' name='cbFacilitatorOfIrpTeamMeeting_3' className='add-only' value='Facilitator of IRP team meeting(s)' /> Facilitator of IRP team meeting(s) <br />
                            <input type='checkbox' id='cbParticipatedPlanningMeeting_3' name='cbParticipatedPlanningMeeting_3' className='add-only' value='Participated in @ least 1 planning meeting' /> Participated in @ least 1 planning meeting <br />
                            <input type='checkbox' id='cbProvidedWrittenInput_3' name='cbProvidedWrittenInput_3' className='add-only' value='Provided written input' /> Provided written input <br />
                            <input type='checkbox' id='cbTelephoneParticipation_3' name='cbTelephoneParticipation_3' className='add-only' value='Telephone participation' /> Telephone participation <br />
                            <input type='checkbox' id='cbInvitedButNoParticipation_3' name='cbInvitedButNoParticipation_3' className='add-only' value='Invited, but no participation' /> Invited, but no participation <br />
                            <input type='checkbox' id='cbRoleOther_3' name='cbRoleOther_3' className='add-only' value='Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtRoleOther_1' name='txtRoleOther_1' className='add-only custom-add-only w-250' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'> 4. Name: </span></td>
                        <td className='w-375'><span className='eleHeader'> Relation/Agency: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtName_4' name='txtName_4' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtRelationAgency_4' name='txtRelationAgency_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Role: </span>

                            <input type='checkbox' id='cbFacilitatorOfIrpTeamMeeting_4' name='cbFacilitatorOfIrpTeamMeeting_4' className='add-only' value='Facilitator of IRP team meeting(s)' /> Facilitator of IRP team meeting(s) <br />
                            <input type='checkbox' id='cbParticipatedPlanningMeeting_4' name='cbParticipatedPlanningMeeting_4' className='add-only' value='Participated in @ least 1 planning meeting' /> Participated in @ least 1 planning meeting <br />
                            <input type='checkbox' id='cbProvidedWrittenInput_4' name='cbProvidedWrittenInput_4' className='add-only' value='Provided written input' /> Provided written input <br />
                            <input type='checkbox' id='cbTelephoneParticipation_4' name='cbTelephoneParticipation_4' className='add-only' value='Telephone participation' /> Telephone participation <br />
                            <input type='checkbox' id='cbInvitedButNoParticipation_4' name='cbInvitedButNoParticipation_4' className='add-only' value='Invited, but no participation' /> Invited, but no participation <br />
                            <input type='checkbox' id='cbRoleOther_4' name='cbRoleOther_4' className='add-only' value='Other:' /> Other:
                            &nbsp;
                            <input type='text' id='txtRoleOther_1' name='txtRoleOther_1' className='add-only custom-add-only w-250' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <b> Other individuals that I or my family would like to be part of this planning process now or in the future. </b> </p>

                <table>
                    <tr>
                        <td className='w-30'> </td>
                        <td className='w-200'> <span className='eleHeader'> (ICD-10/DSM V* Code) </span> </td>
                        <td className='w-320'> <span className='eleHeader'> <center> (Diagnosis Name) </center> </span> </td>
                        <td className='w-200'> <span className='eleHeader'> <center> (Diagnosis Date) </center> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-30'> 1. </td>
                        <td className='w-200'> <input type='text' id='txtIcdDsmCode_1' name='txtIcdDsmCode_1' className='add-only' /> </td>
                        <td className='w-320'> <input type='text' id='txtDiagnosisName_1' name='txtDiagnosisName_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDiagnosisDate_1' name='txtDiagnosisDate_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-30'> 2. </td>
                        <td className='w-200'> <input type='text' id='txtIcdDsmCode_2' name='txtIcdDsmCode_2' className='add-only' /> </td>
                        <td className='w-320'> <input type='text' id='txtDiagnosisName_2' name='txtDiagnosisName_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDiagnosisDate_2' name='txtDiagnosisDate_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-30'> 3. </td>
                        <td className='w-200'> <input type='text' id='txtIcdDsmCode_3' name='txtIcdDsmCode_3' className='add-only' /> </td>
                        <td className='w-320'> <input type='text' id='txtDiagnosisName_3' name='txtDiagnosisName_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDiagnosisDate_3' name='txtDiagnosisDate_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-30'> 4. </td>
                        <td className='w-200'> <input type='text' id='txtIcdDsmCode_4' name='txtIcdDsmCode_4' className='add-only' /> </td>
                        <td className='w-320'> <input type='text' id='txtDiagnosisName_4' name='txtDiagnosisName_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDiagnosisDate_4' name='txtDiagnosisDate_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-30'> 5. </td>
                        <td className='w-200'> <input type='text' id='txtIcdDsmCode_5' name='txtIcdDsmCode_5' className='add-only' /> </td>
                        <td className='w-320'> <input type='text' id='txtDiagnosisName_5' name='txtDiagnosisName_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDiagnosisDate_5' name='txtDiagnosisDate_5' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> RECOMMENDATIONS FOR SERVICES/SUPPORT/TREATMENT BASED ON ASSESSMENTS </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> FREQUENCY: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> DURATION: </center> </span> </td>
                        <td className='w-150'> <span className='eleHeader'> <center> TARGET DATE: </center> </span> </td>
                        <td className='w-150'> <span className='eleHeader'> <center> INSURANCE PROVIDER </center> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtTreatmentBasedOnAssessments_1' name='txtTreatmentBasedOnAssessments_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuration_1' name='txtDuration_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_1' name='txtTargetDate_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtInsuranceProvider_1' name='txtInsuranceProvider_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtTreatmentBasedOnAssessments_2' name='txtTreatmentBasedOnAssessments_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuration_2' name='txtDuration_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_2' name='txtTargetDate_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtInsuranceProvider_2' name='txtInsuranceProvider_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtTreatmentBasedOnAssessments_3' name='txtTreatmentBasedOnAssessments_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuration_3' name='txtDuration_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_3' name='txtTargetDate_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtInsuranceProvider_3' name='txtInsuranceProvider_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtTreatmentBasedOnAssessments_4' name='txtTreatmentBasedOnAssessments_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuration_4' name='txtDuration_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_4' name='txtTargetDate_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtInsuranceProvider_4' name='txtInsuranceProvider_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtTreatmentBasedOnAssessments_5' name='txtTreatmentBasedOnAssessments_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency_5' name='txtFrequency_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuration_5' name='txtDuration_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_5' name='txtTargetDate_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtInsuranceProvider_5' name='txtInsuranceProvider_5' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center> <b> IRP </b> <br /> (Must be SMART: Specific, Measurable, Achievable, Realistic, Time Limited and MUST address goals identified on the treatment plan).</center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Need/Problem 1:</span>
                    Assessment/Diagnostics <b> (Tell why the assessments/plan are needed/tell what the problem is that will tie to the goal/obj/intervention based on each person. Please remove upon completing the plan.) </b>
                    <textarea id='txtNeedProblem_1' name='txtNeedProblem_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Goal 1:</span> Add What does the Individual wants to see overall in treatment? For example, “I know that I get really upset and fight. I need to participate in all of the services and take my medication all the time so I don't fight anymore (this can be changed according to the Individual's whishes) (remove this entire comment after you put in the Individua's statement.)
                    <textarea id='txtGoal_1' name='txtGoal_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Objective 1A:</span>  Over the next 90 days <b> (IF YOU ARE GOING TO DO 6 MONTH TARGET DATES, CHANGE THIS TO 6 MONTHS AND THEN REMOVE THIS PART) </b> Individual will participate in all of the initial and updated psychiatric and nursing assessments, behavioral health assessment, CANS/ANSA assessment (Change to what is being done), service plan development (SPD), Safety plan and Suicide Risk Assessments ( CSSRS) missing no more than 1 apt per service, per quarter.
                    <textarea id='txtObjective_1' name='txtObjective_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>Target Date:</b><input type='date' id='txtTargetDate' name='txtTargetDate' className='add-only' />
                </p>






                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Intervention 1A1: Assessor will meet with Individual <b> (and FAMILY or whoever is helping CAN BE ADDED) </b> to complete an initial or update the behavioral health assessment via biopsychosocial assessment. </td>
                        <td className='w-100'> 1-4x Quarterly </td>
                        <td className='w-100'> H0031 </td>
                        <td className='w-250'> ST/LAPC/LPC/LMSW/LCSW/RN </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A2: Assessor will meet with Individual <b> (and FAMILY or whoever is helping CAN BE ADDED) </b> to complete the initial or update the service plan. </td>
                        <td className='w-100'> 1-4x Quarterly </td>
                        <td className='w-100'> H0032 </td>
                        <td className='w-250'> ST/LAPC/LPC/LMSW/LCSW/RN </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A3: Assessor will meet with Individual <b> (and FAMILY or whoever is helping CAN BE ADDED) </b> to complete or update the CANS/ANSA scales <b> (PLEASE CHANGE BASED ON WHICH ONE IS DONE).</b> </td>
                        <td className='w-100'> 1-4x Quarterly </td>
                        <td className='w-100'> H0032 </td>
                        <td className='w-250'> PP/ST/LAPC/LPC/LMSW/LCSW/RN (Must be certified) </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A3: Assessor will meet with Individual <b> (and FAMILY or whoever is helping CAN BE ADDED) </b> to complete or update the CSSRS/ suicide risk assessment <b> (PLEASE CHANGE BASED ON WHICH ONE IS DONE). </b> </td>
                        <td className='w-100'> 1-4x Quarterly </td>
                        <td className='w-100'> H0031 </td>
                        <td className='w-250'> PP/ST/LAPC/LPC/LMSW/LCSW/RN (Must be certified) </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A1: Assessor will meet with Individual <b> (and FAMILY or whoever is helping CAN BE ADDED) </b> to complete an initial or update the behavioral health assessment via biopsychosocial assessment. </td>
                        <td className='w-100'> 1-4x Quarterly </td>
                        <td className='w-100'> H0031 </td>
                        <td className='w-250'> ST/LAPC/LPC/LMSW/LCSW/RN </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A4: Assessor will meet with Individual <b> (and FAMILY or whoever is helping CAN BE ADDED) </b> to complete or update Safety/Crisis Plan. </td>
                        <td className='w-100'> 1-4x Quarterly </td>
                        <td className='w-100'> 90837/90847 </td>
                        <td className='w-250'> ST/LAPC/LPC/LMSW/LCSW/RN </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A5: Psychiatrist/Doctor will administer a Psychiatric assessment to determine diagnosis, complete psych evaluations, assess/confirm dx, determine tx needs, and will facilitate visits to assess medication effectiveness. </td>
                        <td className='w-100'> 1-4x Quarterly or as needed </td>
                        <td className='w-100'> Psychiatric Services, Assessment and Medication management. </td>
                        <td className='w-250'> MD/PA/NP </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A6: Nurse will administer an assessment to assess mental health and physical health needs, and will facilitate monthly well visits to educate Individual on their medications, obtain vitals, monitor weight, etc. </td>
                        <td className='w-100'> 1-4x Quarterly </td>
                        <td className='w-100'> T1001, T1002 </td>
                        <td className='w-250'> RN </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A7: Assessor will complete diagnostic assessment to include but not limited to history, mental status exam, etc.; to confirm or rule out verifiable diagnosis. </td>
                        <td className='w-100'> 1x yearly </td>
                        <td className='w-100'> Diagnostic Services </td>
                        <td className='w-250'> LPC/LCSW/LMFT/NP/PA </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A8: Staff will meet with Individual to introduce services and build a rapport.  Collaboration with collateral contact will be made to ensure goal is met. </td>
                        <td className='w-100'> 1-4x Monthly </td>
                        <td className='w-100'> Individual counseling/ CSI </td>
                        <td className='w-250'> PP/ST/LAPC/LPC/LMSW/LCSW </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A9: Therapist/ST/PP will respond to crisis events for individual and help her to return to base line functioning to ensure that she is safe for herself or other. Will use a variety of interventions to ensure that she is able to be maintained in her current setting or ensure that she receives proper treatment. Collaboration with collateral contact will be made to ensure goal is met. </td>
                        <td className='w-100'> As needed, not to exceed  5 units </td>
                        <td className='w-100'> Crisis Services </td>
                        <td className='w-250'> PP/ST/LAPC/LPC/LMSW/LCSW </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1A10: Assessor/ Psychologist will complete psychological assessments/ interpret data and report findings to determine diagnosis or other needed information. Collaboration with collateral contact will be made to ensure goal is met. </td>
                        <td className='w-100'> 1-5 units </td>
                        <td className='w-100'> Psychological services </td>
                        <td className='w-250'> LPC/LCSW/MD/NP/PA </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b> Objective 1B: </b> &nbsp;
                    Within the next 90 days, Individual and/or family &nbsp;
                    <input type='text' id='txtProviderName_1' name='txtProviderName_1' placeholder='change based on age' className='add-only w-200 custom-add-only' /> &nbsp;
                    will identify at least 5 community resources that can help &nbsp;
                    <input type='text' id='txtProviderName_2' name='txtProviderName_2' placeholder='put in him or her depending on gender' className='add-only w-200 custom-add-only' /> &nbsp;
                    with managing &nbsp;
                    <input type='text' id='txtProviderName_3' name='txtProviderName_3' placeholder='put in his or her depending on gender' className='add-only w-200 custom-add-only' /> &nbsp;
                    mental health &nbsp;
                    <input type='text' id='txtProviderName_4' name='txtProviderName_4' placeholder='Can add their DX here' className='add-only w-200 custom-add-only' /> &nbsp;
                    and physical health &nbsp;
                    <input type='text' id='txtProviderName_5' name='txtProviderName_5' placeholder='If they have a physical issue be specific and put it here like Type 1 Diabetes, ec' className='add-only w-200 custom-add-only' /> &nbsp;
                    needs and improve the quality of &nbsp;
                    <input type='text' id='txtProviderName_6' name='txtProviderName_6' placeholder='his/her' className='add-only w-200 custom-add-only' /> &nbsp;
                    daily life and actively pursue 1 resource weekly.
                </p>

                <p className='w-750'> <b> THIS IS ANOTHER EXAMPLE OF ONE DONE MORE SPECIFIC TO WHAT THE INDIVIDUAL WANTED: Individual and/or her mother will identify and use at least 2 community resources (i.e., referral to CHINS program, identify groups such as dance that Individual would like to participate in, housing resources, etc) each week, to help her improve daily life functioning and reduce out of home placement. </b> </p>

                <p className='w-750 '>
                    <b>TARGET DATE:</b> <input type='date' id='txtTargetDate_11' name='txtTargetDate_11' className='add-only' />
                </p>

                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1B1: <b> YOU CAN ADD AS MANY AS NEEDED FOR EACH SERVICE, SPECIFY THE SERVICE. EX. </b> Staff will ensure/teach Individual community resource linkages to needed psychiatric, psychological, medical, nursing, educational, and other community resources, including mental/physical health maintenance (i.e. medication, outpatient appointments, psychoeducation, etc.) to help improve the quality of life of the Individual. Collaboration with collateral contact will be made to ensure goal is met. </td>
                        <td className='w-100'> Based on service </td>
                        <td className='w-100'>
                            This can be Case Management (ADULTs only)
                            <br />
                            Add a Family skills training intervention for Children
                        </td>
                        <td className='w-250'> ST/PP </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1B1: <b> YOU CAN ADD AS MANY AS NEEDED FOR EACH SERVICE, SPECIFY THE SERVICE. EX. </b> Staff will teach Individual skills to help them engage in the community, understand the importance of psychiatric, psychological, medical, nursing, educational, appts, including mental/physical health maintenance (i.e. medication, outpatient appointments, psychoeducation, etc.) to help improve the quality of life of the Individual. Collaboration with collateral contact will be made to ensure goal is met. </td>
                        <td className='w-100'> Based on service </td>
                        <td className='w-100'> PRS or CSI depending on the client age </td>
                        <td className='w-250'> ST/PP </td>
                    </tr>

                    <tr>
                        <td className='w-300'> Intervention 1B2: : Therapist will process and explore, through the use of a variety of CB, with Individual and/or family thought processes and barriers that exist that keep them from being successful in being involved in the community, increasing social support and using healthy communication. Collaboration with collateral contact will be made to ensure goal is met. </td>
                        <td className='w-100'> Based on recommendation </td>
                        <td className='w-100'> Individual counseling </td>
                        <td className='w-250'> ST/ APC/ LPC/ LMSW/ LCSW </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b> Objective 1C:  CAN DELETE THIS UNLESS THERE NEEDS TO BE A RAPPORT BUILDING OBJECTIVE OR SOMETHING ELSE NEED TO BE ADDRESSED FOR THE WHOLE HEALTH PART OF THE PLAN (HEALTH ISSUES, WEIGHT LOSS, ETC.) </b>
                </p>

                <p className='w-750' >
                    <b>TARGET DATE:</b> <input type='date' id='txtTargetDate_111' name='txtTargetDate_111' className='add-only' />
                </p>

                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'> <input id='txtIntervention_1c1' name='txtIntervention_1c1' type='text' className='add-only' value={'Intervention 1C1:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_Intervention1c1' name='txtFrequency_Intervention1c1' type='text' className='add-only' /></td>
                        <td className='w-100'><input id='txtServices_Intervention1c1' name='txtServices_Intervention1c1' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtStaff_Intervention1c1' name='txtStaff_Intervention1c1' type='text' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input id='txtIntervention_1c2' name='txtIntervention_1c2' type='text' className='add-only' value={'Intervention 1C2:'} /> </td>
                        <td className='w-100'><input id='txtFrequency_Intervention1c2' name='txtFrequency_Intervention1c2' type='text' className='add-only' /></td>
                        <td className='w-100'><input id='txtServices_Intervention1c2' name='txtServices_Intervention1c2' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtStaff_Intervention1c2' name='txtStaff_Intervention1c2' type='text' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Status Codes: </span>

                    <input type='radio' id='rbStatusCodes_R' name='rbStatusCodes' className='add-only' value='R' />  R=Revised &nbsp;
                    <input type='radio' id='rbStatusCodes_O' name='rbStatusCodes' className='add-only' value='O' /> O=Ongoing &nbsp;
                    <input type='radio' id='rbStatusCodes_A' name='rbStatusCodes' className='add-only' value='A' /> A=Achieved &nbsp;
                    <input type='radio' id='rbStatusCodes_D' name='rbStatusCodes' className='add-only' value='D' /> D=Discontinued

                </p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'> TARGET DATE:  </span>
                            <span className='small'>  (not to exceed 1 year) </span>
                        </td>
                        <td className='w-150'> <span className='eleHeader'> REVIEWED DATE: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> STATUS CODE: </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Justification for Continuation/Discontinuation of Goal </span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input id='txtTarget' name='txtTarget' type='date' className='add-only' /> </td>
                        <td className='w-150'><input id='txtReviewedDate_1' name='txtReviewedDate_1' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_1' name='txtStatusCode_1' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_1' name='txtJustification_1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_2' name='txtReviewedDate_2' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_2' name='txtStatusCode_2' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_2' name='txtJustification_2' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_3' name='txtReviewedDate_3' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_3' name='txtStatusCode_3' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_3' name='txtJustification_3' type='text' className='add-only' /> </td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Need/Problem 2:</span>
                    <b>  List the needs first/then list the problems. This helps with writing a goal that fits their needs and issues. </b>
                    <textarea id='txtNeedProblem_2' name='txtNeedProblem_2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Goal 2: </span>
                </p>
                <p className='w-750'>
                    <textarea id='txtGoal' name='txtGoal' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-600 '> <span className='eleHeader'> Objective 2A: </span> </td>
                        <td className='w-150 '> <span className='eleHeader'> TARGET DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtObjective_2A' name='txtObjective_2A' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_2A' name='txtTargetDate_2A' className='add-only' /> </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_2A1' name='txtIntervention_2A1' type='text' className='add-only' value={'Intervention 2A1:'} />   </td>
                        <td className='w-100'><input id='txtFrequency_2A1' name='txtFrequency_2A1' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2A1' name='txtServices_2A1' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2A1' name='txtStaffType_2A1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_2A2' name='txtIntervention_2A2' type='text' className='add-only' value={'Intervention 2A2:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_2A2' name='txtFrequency_2A2' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2A2' name='txtServices_2A2' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2A2' name='txtStaffType_2A2' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_2A3' name='txtIntervention_2A3' type='text' className='add-only' value={'Intervention 2A3:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_2A3' name='txtFrequency_2A3' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2A3' name='txtServices_2A3' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2A3' name='txtStaffType_2A3' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_2A4' name='txtIntervention_2A4' type='text' className='add-only' value={'Intervention 2A4:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_2A4' name='txtFrequency_2A4' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2A4' name='txtServices_2A4' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2A4' name='txtStaffType_2A4' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600 '> <span className='eleHeader'> Objective 2B: </span> </td>
                        <td className='w-150 '> <span className='eleHeader'> TARGET DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtObjective_2B' name='txtObjective_2B' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_2B' name='txtTargetDate_2B' className='add-only' /> </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_2B1' name='txtIntervention_2B1' type='text' className='add-only' value={'Intervention 2B1:'} />   </td>
                        <td className='w-100'><input id='txtFrequency_2B1' name='txtFrequency_2B1' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2B1' name='txtServices_2B1' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2B1' name='txtStaffType_2B1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_2B2' name='txtIntervention_2B2' type='text' className='add-only' value={'Intervention 2B2:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_2B2' name='txtFrequency_2B2' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2B2' name='txtServices_2B2' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2B2' name='txtStaffType_2B2' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_2B3' name='txtIntervention_2B3' type='text' className='add-only' value={'Intervention 2B3:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_2B3' name='txtFrequency_2B3' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2B3' name='txtServices_2B3' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2B3' name='txtStaffType_2B3' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_2B4' name='txtIntervention_2B4' type='text' className='add-only' value={'Intervention 2B4:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_2B4' name='txtFrequency_2B4' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_2B4' name='txtServices_2B4' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_2B4' name='txtStaffType_2B4' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Status Codes: </span>

                    <input type='radio' id='rbStatusCodesNeedProblem2_R' name='rbStatusCodesNeedProblem2' className='add-only' value='R' />  R=Revised &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem2_O' name='rbStatusCodesNeedProblem2' className='add-only' value='O' /> O=Ongoing &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem2_A' name='rbStatusCodesNeedProblem2' className='add-only' value='A' /> A=Achieved &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem2_D' name='rbStatusCodesNeedProblem2' className='add-only' value='D' /> D=Discontinued

                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'> TARGET DATE:  </span>
                            <span className='small'>  (not to exceed 1 year) </span>
                        </td>
                        <td className='w-150'> <span className='eleHeader'> REVIEWED DATE: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> STATUS CODE: </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Justification for Continuation/Discontinuation of Goal </span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input id='txtTargetNeedProblem2' name='txtTargetNeedProblem2' type='date' className='add-only' /> </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem21' name='txtReviewedDate_NeedProblem21' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem21' name='txtStatusCode_NeedProblem21' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem21' name='txtJustification_NeedProblem21' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem22' name='txtReviewedDate_NeedProblem22' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem22' name='txtStatusCode_NeedProblem22' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem22' name='txtJustification_NeedProblem22' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem23' name='txtReviewedDate_NeedProblem23' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem23' name='txtStatusCode_NeedProblem23' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem23' name='txtJustification_NeedProblem23' type='text' className='add-only' /> </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader' >Need/Problem 3:</span>
                    <textarea id='txtNeedProblem3' name='txtNeedProblem3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Goal 3: </span>
                </p>
                <p className='w-750'>
                    <textarea id='txtGoal_NeedProblem3' name='txtGoal_NeedProblem3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-600 '> <span className='eleHeader'> Objective 3A: </span> </td>
                        <td className='w-150 '> <span className='eleHeader'> TARGET DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtObjective_3A' name='txtObjective_3A' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_3A' name='txtTargetDate_3A' className='add-only' /> </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_3A1' name='txtIntervention_3A1' type='text' className='add-only' value={'Intervention 3A1:'} />   </td>
                        <td className='w-100'><input id='txtFrequency_3A1' name='txtFrequency_3A1' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_3A1' name='txtServices_3A1' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_3A1' name='txtStaffType_3A1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_3A2' name='txtIntervention_3A2' type='text' className='add-only' value={'Intervention 3A2:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_3A2' name='txtFrequency_3A2' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_3A2' name='txtServices_3A2' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_3A2' name='txtStaffType_3A2' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_3A3' name='txtIntervention_3A3' type='text' className='add-only' value={'Intervention 3A3:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_3A3' name='txtFrequency_3A3' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_3A3' name='txtServices_3A3' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_3A3' name='txtStaffType_3A3' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_3A4' name='txtIntervention_3A4' type='text' className='add-only' value={'Intervention 3A4:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_3A4' name='txtFrequency_3A4' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_3A4' name='txtServices_3A4' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_3A4' name='txtStaffType_3A4' type='text' className='add-only' /> </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'> Status Codes: </span>

                    <input type='radio' id='rbStatusCodesNeedProblem3_R' name='rbStatusCodesNeedProblem3' className='add-only' value='R' />  R=Revised &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem3_O' name='rbStatusCodesNeedProblem3' className='add-only' value='O' /> O=Ongoing &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem3_A' name='rbStatusCodesNeedProblem3' className='add-only' value='A' /> A=Achieved &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem3_D' name='rbStatusCodesNeedProblem3' className='add-only' value='D' /> D=Discontinued

                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'> TARGET DATE:  </span>
                            <span className='small'>  (not to exceed 1 year) </span>
                        </td>
                        <td className='w-150'> <span className='eleHeader'> REVIEWED DATE: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> STATUS CODE: </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Justification for Continuation/Discontinuation of Goal </span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input id='txtTargetNeedProblem3' name='txtTargetNeedProblem3' type='date' className='add-only' /> </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem31' name='txtReviewedDate_NeedProblem31' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem31' name='txtStatusCode_NeedProblem31' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem31' name='txtJustification_NeedProblem31' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem32' name='txtReviewedDate_NeedProblem32' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem32' name='txtStatusCode_NeedProblem32' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem32' name='txtJustification_NeedProblem32' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem33' name='txtReviewedDate_NeedProblem33' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem33' name='txtStatusCode_NeedProblem33' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem33' name='txtJustification_NeedProblem33' type='text' className='add-only' /> </td>
                    </tr>

                </table>



                <p className='w-750'>
                    <span className='eleHeader'>Need/Problem 4:</span>
                    <textarea id='txtNeedProblem4' name='txtNeedProblem4' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Goal 4: </span>
                </p>
                <p className='w-750'>
                    <textarea id='txtGoal_NeedProblem4' name='txtGoal_NeedProblem4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-600 '> <span className='eleHeader'> Objective 4A: </span> </td>
                        <td className='w-150 '> <span className='eleHeader'> TARGET DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtObjective_4A' name='txtObjective_4A' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_4A' name='txtTargetDate_4A' className='add-only' /> </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_4A1' name='txtIntervention_4A1' type='text' className='add-only' value={'Intervention 4A1:'} />   </td>
                        <td className='w-100'><input id='txtFrequency_4A1' name='txtFrequency_4A1' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4A1' name='txtServices_4A1' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4A1' name='txtStaffType_4A1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_4A2' name='txtIntervention_4A2' type='text' className='add-only' value={'Intervention 4A2:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_4A2' name='txtFrequency_4A2' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4A2' name='txtServices_4A2' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4A2' name='txtStaffType_4A2' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_4A3' name='txtIntervention_4A3' type='text' className='add-only' value={'Intervention 4A3:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_4A3' name='txtFrequency_4A3' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4A3' name='txtServices_4A3' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4A3' name='txtStaffType_4A3' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_4A4' name='txtIntervention_4A4' type='text' className='add-only' value={'Intervention 4A4:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_4A4' name='txtFrequency_4A4' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4A4' name='txtServices_4A4' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4A4' name='txtStaffType_4A4' type='text' className='add-only' /> </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600 '> <span className='eleHeader'> Objective 4B: </span> </td>
                        <td className='w-150 '> <span className='eleHeader'> TARGET DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtObjective_4B' name='txtObjective_4B' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_4B' name='txtTargetDate_4B' className='add-only' /> </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> <center> Intervention </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Frequency: </center> </span> </td>
                        <td className='w-100'> <span className='eleHeader'> <center> Services: </center> </span> </td>
                        <td className='w-250'> <span className='eleHeader'> <center> Staff Type: </center> </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_4B1' name='txtIntervention_4B1' type='text' className='add-only' value={'Intervention 4B1:'} />   </td>
                        <td className='w-100'><input id='txtFrequency_4B1' name='txtFrequency_4B1' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4B1' name='txtServices_4B1' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4B1' name='txtStaffType_4B1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_4B2' name='txtIntervention_4B2' type='text' className='add-only' value={'Intervention 4B2:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_4B2' name='txtFrequency_4B2' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4B2' name='txtServices_4B2' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4B2' name='txtStaffType_4B2' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-300'><input id='txtIntervention_4B3' name='txtIntervention_4B3' type='text' className='add-only' value={'Intervention 4B3:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_4B3' name='txtFrequency_4B3' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4B3' name='txtServices_4B3' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4B3' name='txtStaffType_4B3' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><input id='txtIntervention_4B4' name='txtIntervention_4B4' type='text' className='add-only' value={'Intervention 4B4:'} />  </td>
                        <td className='w-100'><input id='txtFrequency_4B4' name='txtFrequency_4B4' type='text' className='add-only' /> </td>
                        <td className='w-100'><input id='txtServices_4B4' name='txtServices_4B4' type='text' className='add-only' /> </td>
                        <td className='w-250'><input id='txtStaffType_4B4' name='txtStaffType_4B4' type='text' className='add-only' /> </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'> Status Codes: </span>

                    <input type='radio' id='rbStatusCodesNeedProblem4_R' name='rbStatusCodesNeedProblem4' className='add-only' value='R' />  R=Revised &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem4_O' name='rbStatusCodesNeedProblem4' className='add-only' value='O' /> O=Ongoing &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem4_A' name='rbStatusCodesNeedProblem4' className='add-only' value='A' /> A=Achieved &nbsp;
                    <input type='radio' id='rbStatusCodesNeedProblem4_D' name='rbStatusCodesNeedProblem4' className='add-only' value='D' /> D=Discontinued

                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'> TARGET DATE:  </span>
                            <span className='small'>  (not to exceed 1 year) </span>
                        </td>
                        <td className='w-150'> <span className='eleHeader'> REVIEWED DATE: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> STATUS CODE: </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Justification for Continuation/Discontinuation of Goal </span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input id='txtTargetNeedProblem4' name='txtTargetNeedProblem4' type='date' className='add-only' /> </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem41' name='txtReviewedDate_NeedProblem41' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem41' name='txtStatusCode_NeedProblem41' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem41' name='txtJustification_NeedProblem41' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem42' name='txtReviewedDate_NeedProblem42' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem42' name='txtStatusCode_NeedProblem42' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem42' name='txtJustification_NeedProblem42' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp; </td>
                        <td className='w-150'><input id='txtReviewedDate_NeedProblem43' name='txtReviewedDate_NeedProblem43' type='date' className='add-only' /> </td>
                        <td className='w-100'><input id='txtStatusCode_NeedProblem43' name='txtStatusCode_NeedProblem43' type='text' className='add-only' /> </td>
                        <td className='w-300'><input id='txtJustification_NeedProblem43' name='txtJustification_NeedProblem43' type='text' className='add-only' /> </td>
                    </tr>

                </table>




                {/* HERE */}

                <p className='w-750'> <center> <b> SNAP </b> </center>   </p>

                <p className='w-750'>
                    <span className='eleHeader'>  Strength: What are some of the things about your current situation or your surroundings that will assist you in your treatment?  </span>
                </p>
                <p className='w-750'>
                    <textarea id='txtStrength' name='txtStrength' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Needs: What are some of the things you believe are necessary in order for you to be successful in completing a program? </span>
                </p>
                <p className='w-750'>
                    <textarea id='txtNeeds' name='txtNeeds' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Abilities: What are some of your personal qualities, skills and talents that will assist you in your program? </span>
                </p>
                <p className='w-750'>
                    <textarea id='txtAbilities' name='txtAbilities' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Preferences: What are some of your preferences when considering a treatment program? </span>
                </p>
                <p className='w-750'>
                    <textarea id='txtPreferences' name='txtPreferences' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Hopes: </span>

                    <input type='text' id='txtHopes' name='txtHopes' className='add-only ' />
                </p>

                <p className='w-750'>
                    <center>
                        <h3> TRANSITION /DISCHARGE PLAN </h3>
                        <br />
                        (Step down service needs to be defined what service stepping down to [i.e. CSI, Individual] and from services.)
                        <br />
                        Must be S.M.A.R.T
                    </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Projected Date of Discharge/Transition: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Anticipated Step-Down Service: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtProjectedDateOfDischarge' name='txttxtProjectedDateOfDischarge' className='add-only' />
                        </td>
                        <td className='w-375'> <input type='text' id='txtAnticipatedStepDownService' name='txtAnticipatedStepDownService' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Plans for Transition/Discharge: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtPlansForTransition' name='txtPlansForTransition' className='add-only'> </textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center> <h3> SIGNATURES </h3>
                    </center>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> I. PERSON RECEIVING SERVICES: </span>
                    <input type='checkbox' id='cbPersonReceivingServices_1' name='cbPersonReceivingServices_1' className='add-only' value='I confirm and agree' /> I confirm and agree with my involvement in the development of this SPD. My signature means that I agree with the services/supports to be provided
                    <br />
                    <input type='checkbox' id='cbPersonReceivingServices_2' name='cbPersonReceivingServices_2' className='add-only' value='choice of service providers' /> I understand that I have the choice of service providers and may change service providers at any time, by contacting the person responsible for this SPD
                </p>

                <p className='w-750'>
                    <b> Person Receiving Services </b>
                    (Required when person is his/her own legally responsible person)
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Signature </td>
                        <td className='small w-250'> Name </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Legally Responsible Person: </span>
                    <b> Self: </b>
                    <input type='radio' id='rbLegallyResponsiblePerson_Yes' name='rbLegallyResponsiblePerson' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLegallyResponsiblePerson_No' name='rbLegallyResponsiblePerson' className='add-only' value='No' /> No &nbsp;
                </p>

                <p className='w-750'>
                    <b> Legally Responsible Person (Required if other than person receiving Services) </b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Signature </td>
                        <td className='small w-250'> Name </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Relationship to the Individual:   </td>
                    </tr>
                </table>

                <p className='w-750'> <b> II. PERSON RESPONSIBLE FOR THE IRP: </b> The following signature confirms the responsibility of the clinician for the development of this SPD. The signature indicates agreement with the services/supports to be provided.
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Signature/Credentials of Person responsible for the SPD
                        </td>
                        <td className='small w-250'> Name </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

            </div>
        </form >

    )
}